import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card, CardActionArea, CardContent, CardMedia, Grid, Stack, Typography } from '@mui/material'
import { Alert, SearchInput } from '@carsys/ui'
import { useFilter } from 'app/hooks/useFilter'
import { IShopWholesaler } from '@cbgms/api'
import { KeyType, isKeyType } from '@cbgms/base/utils/keyevent'

interface SelectWholesalerProps {
  hideSearch: boolean
  wholesalers: IShopWholesaler[]
  onSelect: (wholesaler: IShopWholesaler) => void
}

export const SelectWholesaler: React.FC<SelectWholesalerProps> = props => {
  const { hideSearch, wholesalers, onSelect } = props
  const { t } = useTranslation()
  const [filteredWholesalers, setFilter, filter] = useFilter(wholesalers)

  const handlePressEnterKey = (event: React.KeyboardEvent) => {
    if (isKeyType(event, KeyType.EnterKey)) {
      event.stopPropagation()
      event.preventDefault()
      if (filteredWholesalers[0]) {
        onSelect(filteredWholesalers[0])
      }
    }
  }

  const setWholesalerAndResetFilter = (wholesaler: IShopWholesaler) => {
    onSelect(wholesaler)
    setFilter('')
  }
  return (
    <Grid container direction='column' spacing={2}>
      {!hideSearch && (
        <Grid item>
          <SearchInput
            fullWidth
            variant='outlined'
            onKeyDown={handlePressEnterKey}
            onChange={e => setFilter(e.target.value)}
            value={filter}
            placeholder={t('wholesaler.search_wholesaler')}
          />
        </Grid>
      )}
      <Grid item>
        <Grid container spacing={2} data-testid='select-card-grid'>
          {filteredWholesalers.map((item, index: number) => (
            <Grid item md={4} xs={4} key={index} display='flex' flexDirection='column'>
              <Card sx={{ flex: 1 }} onClick={() => setWholesalerAndResetFilter(item)} data-testid='select-card-item'>
                <CardActionArea sx={{ height: '100%' }}>
                  <CardContent>
                    <Stack direction='row' spacing={2} justifyContent='space-between'>
                      <Box alignSelf='center'>
                        <Typography component='div' variant='inherit'>
                          {item.Name}
                        </Typography>
                      </Box>
                      {item.LogoURL && (
                        <Box>
                          <CardMedia
                            component='img'
                            sx={{ height: '100%', objectFit: 'contain', objectPosition: 'right' }}
                            image={item.LogoURL}
                            alt='logo'
                            data-testid='card-item-logo'
                          />
                        </Box>
                      )}
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
          {filteredWholesalers.length === 0 && (
            <Grid item xs={12}>
              <Alert color='muted'>{t('global.search_no_results_found')}</Alert>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
